export { TermsHero } from "./hero";
export { TermsConditions } from "./conditions";
